<template>
    <div class="d-flex flex-column justify-content-center align-items-center" style="height: 100%">
        <h1 class="fw-bolder" style="font-size: 4rem;">Oops!</h1>
        <el-empty>
            <template #description>
                <h3 class="mb-4">This page does not exist</h3>
                <p>We couldn't find the page you are looking for, please double check the URL.</p>
                <p>If you think this is an error, please contact the {{ $appName }} team. Or you could go back to the home page.</p>
            </template>
            <div class="mt-4">
                <el-button type="primary" plain @click="$router.push({name: 'ContactPage', query: { subject: 'Page Not Found error' }})"><el-icon class="el-icon--left"><Message /></el-icon>Contact {{ $appName }}</el-button>
                <el-button type="primary" @click="$router.replace({name: 'HomePage'})"><el-icon class="el-icon--left"><House /></el-icon>Go to home page</el-button>
            </div>
        </el-empty>
    </div>
</template>

<script>
export default {
    name: 'FourOhThree'
}
</script>